import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import ComponentForm from '../../../components/forms/ComponentForm';
import {
  useComponentById,
  useUpdateComponent,
} from '../../../hooks/useComponentApi';
import { useNavigate, useParams } from 'react-router-dom';
import { ComponentDTO } from '../../../services/apiClient';

const ComponentEdit: React.FC = () => {
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const { id } = useParams<{ id: string }>();
  const { data: entityData } = useComponentById(id!);
  const updateMutation = useUpdateComponent();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Components', href: '/admin/components' },
    { label: 'Edit', href: '#' },
  ];

  const handleSubmit = async (data: any) => {
    try {
      setIsSubmitting(true);
      await updateMutation.mutateAsync({ id: id!, data });
      navigate('/admin/components');
    } catch (error) {
      console.error('Error updating Component:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/components"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission="Settings.Component.Edit"
    >
      {entityData ? (
        <ComponentForm
          initialValues={entityData}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/components')}
          isLoading={isSubmitting}
        />
      ) : (
        <p>Loading...</p>
      )}
    </AdminLayout>
  );
};

export default ComponentEdit;
